import React from 'react';
export var IconOutputPathContext = /*#__PURE__*/React.createContext({
  outputPath: ''
});
export var IconOutputPathProvider = IconOutputPathContext.Provider;